export const SIGNATURE_LABELS = {
  // Acta
  "Acta_UIIE": "UIIE Acta",
  "Acta_Atiende_visita": "Atiende visita",
  "Acta_Testigo_1": "Testigo 1",
  "Acta_Testigo_2": "Testigo 2",
  
  // Solicitud y Contrato
  "Solicitud_UIIE": "UIIE Solicitud",
  "Solicitud_Autoriza": "Autoriza solicitud",
  "Contrato_UIIE": "UIIE contrato",
  "Contrato_Firma": "Firma contrato",
  
  // Portada
  "Portada_Firma": "Firma portada",
  
  // Anexo B
  "Firma_UIIE": "UIIE AnexoB",
  
  // Informe
  "Informe_UIIE": "UIIE Informe",
  
  // Supervisión
  "Supervision_Firma": "Firma Supervisión"
};

export const getSignatureLabel = (name) => {
  return SIGNATURE_LABELS[name] || name;
};
